import type { components } from '../../types/api/generated';
import { ErrorType } from '@components/ErrorBoundary';
import { ffhClient } from '@lib/api/ffh-client';
import { authHeader } from '@lib/api/auth-header';

const TEAM_NOT_FOUND = 404;
const FPL_ID_MISSING = 422;
const SERVICE_UNAVAILABLE = 502;
const INTERNAL_SERVER_ERROR = 500;

export type LiveTeamData = NonNullable<
  components['schemas']['LiveTeamResponse']['data']
>;

export type LiveTeamError = { status: number; message: string };

type FetchLiveTeamOptions = {
  fplId: string;
  accessToken: string;
};

const fetchLiveTeam = async ({
  fplId,
  accessToken
}: FetchLiveTeamOptions): Promise<LiveTeamData | LiveTeamError | false> => {
  if (!fplId) {
    return false;
  }

  try {
    const { data, response } = await ffhClient().GET('/live/team', {
      params: { query: { fplId: Number(fplId) } },
      headers: authHeader(accessToken)
    });

    if (response.status === TEAM_NOT_FOUND) {
      return {
        status: TEAM_NOT_FOUND,
        message: ErrorType.liveRankUserNotFoundError
      };
    }

    if (response.status === FPL_ID_MISSING) {
      return {
        status: FPL_ID_MISSING,
        message: ErrorType.liveRankUserNotFoundError
      };
    }

    if (response.status === SERVICE_UNAVAILABLE) {
      return { status: SERVICE_UNAVAILABLE, message: ErrorType.fplFetchError };
    }

    if (!data) {
      return { status: response.status, message: ErrorType.isLiverankError };
    }

    return data.data;
  } catch (error) {
    console.error('[live-team] unexpected fetch error', error);
    return {
      status: INTERNAL_SERVER_ERROR,
      message: ErrorType.isLiverankError
    };
  }
};

export default fetchLiveTeam;
